/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SalesStatsShippedDetailResponse } from '../../models/sales-stats-shipped-detail-response';

export interface GetSalesStatsShippedDetail$Params {
  productCategoryIds: Array<number>;
  customerIds: Array<number>;
  agentIds: Array<number>;
  dateFrom?: string;
  dateTo?: string;
  isFullMonth?: boolean;
}

export function getSalesStatsShippedDetail(http: HttpClient, rootUrl: string, params: GetSalesStatsShippedDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<SalesStatsShippedDetailResponse>> {
  const rb = new RequestBuilder(rootUrl, getSalesStatsShippedDetail.PATH, 'get');
  if (params) {
    rb.query('productCategoryIds', params.productCategoryIds, {});
    rb.query('customerIds', params.customerIds, {});
    rb.query('agentIds', params.agentIds, {});
    rb.query('dateFrom', params.dateFrom, {});
    rb.query('dateTo', params.dateTo, {});
    rb.query('isFullMonth', params.isFullMonth, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SalesStatsShippedDetailResponse>;
    })
  );
}

getSalesStatsShippedDetail.PATH = '/sales-stats/shipped-detail';
